import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'

export default class WebView extends ApiBase {
  constructor (store) {
    const path = ACTIVE_BASE_REST + '/webView'
    super(store, path)
  }
}